import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import styles from "./consentSteps.module.scss";

export const StepFooter = ({error, stageLabel, disabled, onCancel, onContinue, continueDisabled, onSave, onSend, saving, sending}: {
  error: string;
  stageLabel?: string;
  disabled: boolean;
  onCancel: () => void;
  onContinue?: () => void;
  continueDisabled?: boolean;
  onSave?: () => void;
  onSend?: () => void;
  saving?: boolean;
  sending?: boolean;
}) => <div className={styles.actions}>
  {error ? <p className={styles.error} role="alert">{error}</p> : null}
  {stageLabel ? <p className={styles.stage} role="status">{stageLabel}</p> : null}
  <div className={styles.actionButtons}>
    <Button variant="outlined" onClick={onCancel} disabled={disabled}>Cancel</Button>
    {onContinue ? <Button onClick={onContinue} disabled={disabled || continueDisabled}>Continue</Button> : <div className={styles.actionGroup}>
      <Button variant="outlined" onClick={onSave} isLoading={saving}>Save as draft</Button>
      <Button onClick={onSend} isLoading={sending}>Send</Button>
    </div>}
  </div>
</div>;
